import { render, staticRenderFns } from "./StoperKeyboard.vue?vue&type=template&id=3e542563&scoped=true&"
import script from "./StoperKeyboard.vue?vue&type=script&lang=js&"
export * from "./StoperKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./StoperKeyboard.vue?vue&type=style&index=0&id=3e542563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e542563",
  null
  
)

export default component.exports